"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _ErrorField = _interopRequireDefault(require("./ErrorField"));

var _LiveSaver = _interopRequireDefault(require("./LiveSaver"));

var _Portal = _interopRequireDefault(require("../Portal"));

var _Popup = _interopRequireDefault(require("../Popup"));

var _excluded = ["liveSaver", "tooltip", "label", "required", "className", "meta", "touched", "hasOnWheel", "blurAction", "children"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var FormElementWrapper = function FormElementWrapper(props) {
  var liveSaver = props.liveSaver,
      tooltip = props.tooltip,
      label = props.label,
      required = props.required,
      className = props.className,
      meta = props.meta,
      _props$touched = props.touched,
      touched = _props$touched === void 0 ? false : _props$touched,
      hasOnWheel = props.hasOnWheel,
      blurAction = props.blurAction,
      children = props.children,
      rest = _objectWithoutProperties(props, _excluded);

  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      popupData = _useState2[0],
      setPopupData = _useState2[1];

  var wheel = function wheel(event) {
    return event.stopPropagation();
  };

  var timerIn = null;
  var timerOut = null;

  var openPopup = function openPopup(e) {
    var element = e.target;
    var elementHeight = element.getBoundingClientRect().height;
    var pageX = element.getBoundingClientRect().left;
    var pageY = element.getBoundingClientRect().top + elementHeight;
    clearTimeout(timerOut);
    timerIn = setTimeout(function () {
      return setPopupData({
        pageX: pageX,
        pageY: pageY
      });
    }, 1000);
  };

  var closePopup = function closePopup() {
    clearTimeout(timerIn);
    timerOut = setTimeout(function () {
      return setPopupData(null);
    }, 100);
  };

  var getPopup = function getPopup() {
    return /*#__PURE__*/_react["default"].createElement(_Portal["default"], null, /*#__PURE__*/_react["default"].createElement(_Popup["default"], {
      place: "info-popup",
      point: popupData
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "info-text"
    }, tooltip)));
  };

  var getLabel = function getLabel() {
    return label ? /*#__PURE__*/_react["default"].createElement("div", {
      className: "input-label"
    }, label, required && /*#__PURE__*/_react["default"].createElement("span", {
      className: "required-field"
    }, "*"), tooltip && /*#__PURE__*/_react["default"].createElement("div", {
      className: "tool-tip",
      onMouseEnter: openPopup,
      onMouseLeave: closePopup
    }, /*#__PURE__*/_react["default"].createElement("i", {
      className: "icon-tooltip"
    }), popupData && getPopup())) : null;
  };

  var containerClassName = (0, _classnames["default"])('input-element', {
    'input-element__error': meta && (meta.touched || touched) && !meta.valid
  }, className);
  var onWheel = hasOnWheel ? wheel : undefined;

  var wrapper = /*#__PURE__*/_react["default"].createElement("div", _extends({
    className: containerClassName,
    onWheel: onWheel
  }, rest), getLabel(), children, /*#__PURE__*/_react["default"].createElement(_ErrorField["default"], {
    meta: meta,
    touched: touched
  }));

  return liveSaver ? /*#__PURE__*/_react["default"].createElement(_LiveSaver["default"], {
    liveSaver: liveSaver,
    blurAction: blurAction
  }, wrapper) : wrapper;
};

FormElementWrapper.propTypes = {
  hasOnWheel: _propTypes["default"].bool,
  required: _propTypes["default"].bool,
  meta: _propTypes["default"].object,
  className: _propTypes["default"].string,
  blurAction: _propTypes["default"].bool
};
FormElementWrapper.defaultProps = {
  hasOnWheel: false,
  required: false,
  meta: null,
  className: ''
};
var _default = FormElementWrapper;
exports["default"] = _default;